import EnhancedAdExample from './EnhancedAdExample/EnhancedAdExample';

const EnhancedAdExampleDirective = (
  reactDirective,
  $state,
  CreativeService
) => {
  return reactDirective(
    EnhancedAdExample,
    undefined,
    { restrict: 'E' },
    { $state, CreativeService }
  );
};

EnhancedAdExampleDirective.$inject = [
  'reactDirective',
  '$state',
  'CreativeService'
];

export default EnhancedAdExampleDirective;
